/**
 * Formats an array as a string, with each element separated by commas.
 *
 * @param array: 'An array of stringable things'
 *
 * @example
 * toStringWithOxfordCommas(["One", "Two", "Five"]);
 * // returns "One, Two, and Five"
 *
 * @example
 * toStringWithOxfordCommas(["One"]);
 * // returns "One"
 *
 * toStringWithOxfordCommas(["One", "Five"]);
 * // returns "One and Five"
 *
 * @returns {String}
 */

export const toStringWithOxfordCommas = (array: Array<string>) => {
  const items = [
    ...array.filter(item => {
      return item !== undefined && item !== null;
    }),
  ];
  if (items.length === 1) {
    return items[0];
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }

  const last = items.pop();
  return `${items.join(', ')}, and ${last}`;
};

export const intersperse = <T>(arr: Array<T>, separator: (n: number) => T): Array<T> =>
  arr.reduce<Array<T>>((acc, currentElement, currentIndex) => {
    const isLast = currentIndex === arr.length - 1;
    return [...acc, currentElement, ...(isLast ? [] : [separator(currentIndex)])];
  }, []);
